import styled from 'styled-components';

export const LinkCaption = styled.a`
  color: var(--colors-on-background);
  font-family: var(--typo-caption-font-family);
  font-size: var(--typo-caption-font-size);
  letter-spacing: var(--typo-caption-letter-spacing);
  line-height: var(--typo-caption-line-height);
  font-weight: var(--typo-caption-font-weight);
  text-align: center;
  //desktop or large
  @media (min-width: 1024px) {
    &:hover {
      text-decoration: none;
    }
  }
`;

export const LinkForm = styled.a`
  color: var(--colors-primary-default);
  font-family: var(--typo-caption-font-family);
  font-size: var(--typo-tips-font-size);
  letter-spacing: var(--typo-caption-letter-spacing);
  line-height: var(--typo-caption-line-height);
  font-weight: var(--typo-caption-font-weight);
`;
